

































import { defineComponent, SetupContext } from '@vue/composition-api';

import BaseButton from '@/base/app/components/atoms/BaseButton.vue';
import ErrorMessages from '@/base/app/components/molecules/ErrorMessages.vue';
import TextEditor from '@/base/app/components/molecules/TextEditor.vue';

import { useProblemHeaderDialog } from './ProblemHeaderDialogComposable';

export default defineComponent({
  name: 'ContentsProblemHeaderDialog',
  components: { BaseButton, TextEditor, ErrorMessages },
  inheritAttrs: false,
  emits: ['submit'],
  setup(_, { emit }: SetupContext) {
    return useProblemHeaderDialog(emit);
  },
});
